import styled from 'styled-components'
import { theme } from '~/styles'

interface RadioWrapper {
  error?: boolean
  size?: number
}

export const Wrapper = styled.div`
  display: flex;
`

export const RadioWrapper = styled.label<RadioWrapper>`
  display: flex;
  align-items: center;

  input[type='radio'] {
    vertical-align: middle;
    width: ${({ size }) => size ?? 20}px;
    height: ${({ size }) => size ?? 20}px;
    border-radius: 10px;
    background: none;
    border: 0;
    transition: box-shadow 150ms cubic-bezier(0.95, 0.15, 0.5, 1.25);
    box-shadow: inset 0 0 0 1px ${theme.colors.color6b7786};
    appearance: none;
    padding: 0;
    margin: 0;

    &:hover,
    &:focus {
      outline: none;
      box-shadow: inset 0 0 0 1px ${theme.colors.color378ff7};
    }

    &:checked {
      box-shadow: inset 0 0 0 4px ${({ theme }) => theme.zds.colors.neutral1000};
      background: ${theme.colors.color378ff7};
      border: 1px solid ${theme.colors.color378ff7};
    }

    &:checked + div {
      color: ${theme.colors.color378ff7};
    }
  }

  div {
    cursor: pointer;
    position: relative;
    margin-left: ${({ theme }) => theme.zds.spacing.inline300};
    color: ${({ error }) => (error ? theme.colors.colorFF2424 : theme.colors.color6b7786)};
  }

  &:hover > input {
    box-shadow: inset 0 0 0 1px ${theme.colors.color378ff7};
  }
`

export const RadioElement = styled.input`
  margin: 0;
  width: 20px;
  height: 20px;
  cursor: pointer;
`

export const RadioLabel = styled.div<RadioWrapper>`
  font-size: 12px;
  font-weight: 400;
  display: flex;
  align-items: center;
`
